const { READ_ONLY_FEATURES } = process.env;

const crudConfig = {
    endpoint: 'deploymentqueues',
    primaryKey: 'deploymentId',
    functions: {
        fetchAll: {
            method: 'get',
            returnType: 'Array',
            service: 'rckms',
            args: [],
            query: {
                property: 'queryClass=FindAll'
            }
        },
        fetchOne: {
            method: 'get',
            returnType: 'Object',
            service: 'rckms',
            args: ['deploymentId'],
            query: {
                filter: 'deploymentId=#@deploymentId@#',
                property: 'queryClass=PrimaryKey'
            }
        }
    }
};

if (!READ_ONLY_FEATURES || READ_ONLY_FEATURES === 'false') {
    crudConfig.functions = {
        ...crudConfig.functions,
        update: {
            method: 'put',
            returnType: 'Object',
            service: 'rckms',
            args: ['deploymentId', 'deploymentQueueDoc']
        },
        delete: {
            method: 'delete',
            returnType: 'String',
            service: 'rckms',
            args: ['deploymentId']
        },
        insert: {
            method: 'post',
            returnType: 'Object',
            service: 'rckms',
            args: ['deploymentQueueDoc']
        },
        purge: {
            method: 'purge',
            returnType: 'Object',
            service: 'rckms'
        }
    };
}
export default crudConfig;
